import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionComputerPermissions extends BaseScenesPermissions {}

export default EmissionComputerPermissions
